module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-call-to-action-2.66098e6d.webp";